import evRepairLogo from '../assets/ev-repair-logo.png';
import userIcon from '../assets/dp.png'
import { btnOne, tableData, tableHeader, title } from '../utils/style';
import MenuPreview from './MenuPreview';
import more from '../assets/icons/more.png'
import moment from "moment";

function ManagerPreview({color, button, font, logoUrl, iconUrl, table}) {

    const options = [
        {
            header: 'DATE',
            key: 'date',
            render: (data) => {return data.date && moment(data.date).format('MM-DD-YYYY')},
        },
        {
            header: 'TIME SLOT',
            key: 'time',
        },
        {
            header: 'SERVICE TYPE',
            key: 'serviceType',
        },
        {
            header: 'PRIORITY',
            key: 'priority',
        },
        {
            header: 'VEHICLE INFO',
            key: 'vehicleInfo',
        },
        {
            header: 'ASSIGNED TO',
            key: 'assignedTo',
        }
    ]

    const data = [
        {
            date: '18-05-2024',
            time: '1:35 PM',
            serviceType: 'Quick Service',
            priority: 'high',
            vehicleInfo: 'Tesla - S - 2022',
            assignedTo: 'Mr. Robert'
        },
        {
            date: '18-05-2024',
            time: '1:35 PM',
            serviceType: 'Quick Service',
            priority: 'high',
            vehicleInfo: 'Tesla - S - 2022',
            assignedTo: 'Mr. Robert'
        },
        {
            date: '18-05-2024',
            time: '1:35 PM',
            serviceType: 'Quick Service',
            priority: 'high',
            vehicleInfo: 'Tesla - S - 2022',
            assignedTo: 'Mr. Robert'
        }
    ]

    const buttonStyle = {
        backgroundColor: `rgb(${button?.btnBgColor.rgb.r} ${button?.btnBgColor.rgb.g} ${button?.btnBgColor.rgb.b})`,
        color: `rgb(${button?.btnFontColor.rgb.r} ${button?.btnFontColor.rgb.g} ${button?.btnFontColor.rgb.b})`,
        fontFamily: button?.fontFamily
    }
    const header = {
        backgroundColor: `rgb(${table?.headerColor?.rgb.r} ${table?.headerColor?.rgb.g} ${table?.headerColor?.rgb.b})`,
        color: `rgb(${table?.fontColor?.rgb.r} ${table?.fontColor?.rgb.g} ${table?.fontColor?.rgb.b})`
    }

    
    
    return(
        <div className={' w-full' + ' ' + 'text-' + font.fontSize} style={{fontFamily: font.fontFamily}}>
            <div className={"flex px-3 justify-between"} style={{backgroundColor: `rgb(${color.primaryColor.rgb.r} ${color.primaryColor.rgb.g} ${color.primaryColor.rgb.b})`}}>
                <div className='flex'>
                    <img alt='logo' src={logoUrl?.landingLogo ? logoUrl.landingLogo : evRepairLogo} className='h-16' />
                </div>
                <div className='flex mr-2'>
                    <div className='rounded-full flex gap-4 justify-center items-center font-medium p-2 cursor-pointer'>
                        <img alt='icon' src={ Object.keys(iconUrl).length === 0 ? userIcon : iconUrl} className='rounded-full h-8' />
                    </div>
                    <div className='ml-4 flex flex-col justify-center'>
                        <div className='text-gray-700 text-sm font-semibold'>Name</div>
                        <div className='text-gray-400 text-xs font-semibold'>Manager</div>
                    </div>
                    <div className='flex items-center mx-8'>
                        <img src={more} className={`cursor-pointer`} />
                    </div>
                </div>
            </div>
            <div className='flex'>
                <div className='w-1/4 min-h-96 px-1 pt-1 bg-opacity-25'>
                    <MenuPreview color={color} font={font} />
                </div>
                <div className='w-full'>
                    <div className="p-4 w-full">
                        <div className={title}>Upcoming Appointments</div>

                        {/* <Table data={data} options={options} button={button} table={table} pagination />
                         */}
                        
                        <div className="w-full">
                            <table className='w-full'>
                                <thead>
                                    <tr>
                                        {
                                            options.map((opt, ind) => 
                                                <th 
                                                    data-testid={'th-' + opt.header}
                                                    key={ind} 
                                                    className={ tableHeader }
                                                    style={header}
                                                >
                                                    {opt.header}
                                                </th>
                                            )
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        data.map((dt, ind) => 
                                            <tr key={ind}>
                                                {
                                                    options.map((opt,indx) => 
                                                        <td 
                                                            key={indx} 
                                                            className={ tableData }
                                                        >
                                                            {opt.render ? opt.render(dt, ind) : dt[opt.key]}
                                                        </td> 
                                                    )
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                            <div className="flex justify-center p-4" >
                                <span>
                                    <button
                                        className={`${btnOne} text-${button?.fontSize}`}
                                        style={buttonStyle}
                                    >
                                        Prev
                                    </button>
                                </span>
                                <span className="mx-12 flex items-center font-semibold text-md">Page : 1</span>
                                <span>
                                    <button
                                        className={`${btnOne} text-${button?.fontSize}`}
                                        style={buttonStyle}
                                    >
                                        Next
                                    </button>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ManagerPreview;